import React from 'react';
import '../../scss/components/Select.scss';
import { IOption } from '../../interface/IOption';

import {default as ReactSelect} from 'react-select'

const Select = (props:any) => {
    let selectProps = {...props};
    if (!selectProps.labelPosition) {
        selectProps.labelPosition = 'before';
    }
    const options = props.options;
    const value = props.defaultValue;
    let defaultOptions = options.filter((option:IOption) => option.value === value);
    if (defaultOptions.length > 0) {
        selectProps.defaultValue = defaultOptions[0];
    }

    return (
        <div className={`form-group custom-select${selectProps.wrapperClassName ? ' ' + selectProps.wrapperClassName : ''}`}>
            {selectProps.label && selectProps.label.length > 0 && selectProps.labelPosition === 'before' ? (
                <label htmlFor={selectProps.name}>{selectProps.label} {selectProps.isRequired ? '*' : ''}</label>
            ) : <></>}
            <ReactSelect
                unstyled
                className={`custom-select-container${selectProps.error ? ' invalid' : ''}${selectProps.menuPlacement === 'top' ? ' menu-top' : ''}`}
                classNamePrefix="custom-select"
                aria-label={selectProps.label + (selectProps.isRequired ? ' (Erforderlich)' : '')}
                lang="de"
                noOptionsMessage={(obj) => 'Keine Optionen'}
                loadingMessage={(obj) => 'Wird geladen...'}
                aria-required={selectProps.isRequired ? 'true' : 'false'}
                {...selectProps}
            />
            {selectProps.label && selectProps.label.length > 0 && selectProps.labelPosition === 'after' ? (
                <label htmlFor={selectProps.name}>{selectProps.label} {selectProps.isRequired ? '*' : ''}</label>
            ) : <></>}
            { selectProps.error && (
                <span className='form-error'>{ selectProps.error }</span>
            ) }
        </div>
    )
}

export default Select;
